import { CountriesAPI } from "@/core/api";

/**
 * Fetch autocomplete locations based on user input.
 * @param {*} input input string from user
 * @param {*} type type of location to autocomplete
 * @returns {Promise<Array>} - A promise that resolves to an array of location suggestions.
 */
export async function autocompleteLocations(input, type) {
    try {
        if (input.length > 2) {
            let { data } = await CountriesAPI.autocompleteLocations(input, type);
            if (data.code === 200) {
                return data.data
            }
        }
        return [];
    } catch (error) {
        console.error("Error fetching autocomplete locations:", error);
        return [];
    }
}

/**
 * Determine the type of location based on reservation type and origin.
 * @param {string} type - The type of reservation (e.g., "arrival", "departure").
 * @param {string} origin - The origin of the location ("from" or "to").
 * @returns {string} - The determined location type ("airport" or "point_of_interest").
 */
export function getTypeLocation(type, origin) {
    if (type === "ARRIVAL" && origin === "from") {
        return "airport";
    }
    if (type === "DEPARTURE" && origin === "to") {
        return "airport";
    }
    return "point_of_interest";
}

/** Format location data for API request.
 * @param {Object} point - The location point object.
 * @returns {Object|string} - Formatted location data for the request.
 */
export function formatLocationForRequest(point) {
    if (point && point.lat && point.lng && point.country) {
        return point;
    }
    return point.name;
}

/** Get icon class based on location type.
 * @param {string} type - The type of location.
 * @returns {string} - The corresponding icon class.
 */
export function getLocationIcon(type) {
    if (type === "airport") {
        return "flaticon-bold-plane";
    } else if (type === "lodging") {
        return "flaticon-bold-bed";
    } else if (type === "point_of_interest") {
        return "flaticon-bold-map";
    } else if (type === "route") {
        return "flaticon-bold-distance";
    } else if (type === "train_station" && type === "transit_station") {
        return "flaticon-bold-train";
    }
    return "flaticon-bold-map";
}

/** Get location type based on transfer type.
 * @param {string} type - The type of transfer.
 * @returns {string} - The corresponding location type.
 */
export function getLocationType(type, locationType) {
    if (type === "ARRIVAL" && locationType === "origin") {
        return "airport";
    } else if (type === "DEPARTURE" && locationType === "destination") {
        return "airport";
    } else if (type === "STATION") {
        return "train_station";
    }
    return "point_of_interest";
}